export class AlarmGroup {
    groupNo: number;
    id: string;
    name: string;
    vesselId: string;
    description: string;
    categories: string[];
    outputSettings?: OutputAddress[];
}

export const alarmGroupNameMaxLimit = 28;
export const descriptionMaxLimit = 20;

export interface AlarmGroupConsolePayload {
    vesselId: string;
    alarmGroupId: string;
    event: ConsoleSettingEvent;
    ouputs: OutputConsoleSetting[];
}

export interface OutputConsoleSetting {
    id?: string;
    alarmGroupId: string;
    slotId: string;
    terminalNum: number;
    index: number;
    type: OutputSettingType;
    mode: OutputSettingMode;
    signal?: number;
}

export enum ConsoleSettingEvent {
    UNDEFINED = 'undefined',
    CREATING = 'console-setting-creating',
    UPDATING = 'console-setting-updating',
}

export interface SettingsAddress {
    fcuNum: number;
    fuNum: number;
    slotNum: number;
    terminal: number;
    settingId?: string;
}

export const SignalWidthMin = 200;
export const SignalWidthMax = 2000;
export const SignalWidthDefault = 700;

export class OutputAddress {
    index: number;
    type: OutputSettingType;
    mode: OutputSettingMode;
    address: SettingsAddress;
    signal?: number;

    constructor(num) {
        this.index = num;
        this.type = null;
        this.mode = OutputSettingMode.NEITHER;
        this.address = undefined;
        this.signal = null;
    }
}

export enum OutputSettingType {
    UNDEFINED = 'undefined',
    ONE_SHOT = 'one-shot',
    CONTINUOUS = 'continuous',
    FLASHING = 'flashing',
    BUZZER = 'buzzer',
}

export enum OutputSettingMode {
    UNDEFINED = 'undefined',
    FUNCTION = 'function-test',
    LAMP = 'lamp-test',
    BOTH = 'both',
    NEITHER = 'neither',
}

export interface AlarmGroupFcu {
    [fcuNum: number]: AlarmGroupSetting[];
}

export class AlarmGroupSetting {
    trigger_channel_id: number;
    alarm_group_number: number;
}

export function getOutputSettingTypeString(type: OutputSettingType) {
    if (!type) return '';
    else if (type == OutputSettingType.ONE_SHOT) return 'One-shot';
    else if (type == OutputSettingType.CONTINUOUS) return 'Continuous';
    else if (type == OutputSettingType.FLASHING) return 'Flashing';
    else if (type == OutputSettingType.BUZZER) return 'Alarm Buzzer';
    return '';
}
